// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__adtvS","loading":"style_loading__Fbt9v","container":"style_container__cD74z"};